import Component from '@glimmer/component';
import ActionItemTemplate from 'garaje/components/homepage/kiosk-demo/pages/templates/action-item-template';
import PageTemplate from 'garaje/components/homepage/kiosk-demo/pages/templates/page-template';

import type { KioskDemoPage } from '../provider';

export default class Photo extends Component<KioskDemoPage> {
  get shareLink(): string {
    if (this.args.firstFlowId) {
      return `/visitors/settings/visitor-types/${this.args.firstFlowId}/visitor-photos`;
    }
    return '/visitors/settings';
  }

  <template>
    <PageTemplate
      @headerTitle="Visitor photo"
      @headerInfo="By enabling sign-in photos, you can also capture photos of all your visitors. This may help you recognize them later."
      @currentStep={{@currentStep}}
      @totalStepCount={{@totalStepCount}}
      @demoName={{@demoName}}
      @isUserLoggedIn={{@isUserLoggedIn}}
      @isDemoInstance={{@isDemoInstance}}
    >
      <div>
        <ActionItemTemplate
          @header="Enable visitor photos"
          @headerInfo="Snap photos of each visitor."
          @subHeader="Required plan: Premium"
          @iconLink="/assets/images/ipad-demo/icons/photo.svg"
          @iconAlt="Image of photo of guest"
          @pageLink={{this.shareLink}}
          @isUserLoggedIn={{@isUserLoggedIn}}
          @demoName={{@demoName}}
          @isDemoInstance={{@isDemoInstance}}
        />
      </div>
    </PageTemplate>
  </template>
}
